<template>
  <div class="manage-content">
    <!-- 隐藏的弹窗 预览内容 -->
    <el-dialog
            title="预览内容"
            :visible.sync="dialogCode"
            width="400px">
      <div class="center">
        <qriously :value="'https://' + orderTaskUrl" :size="250" />
        <span>微信扫一扫查看推广内容</span>
      </div>
    </el-dialog>
    <div class="flex align-items">
      <!-- top流程 -->
      <div class="release-steps">
        <ul class="flex">
          <li :class="{'item flex align-items current':showStep === 1,'item flex align-items already':showStep === 2 || showStep === 3}">
            <span class="num">1</span>
            <span class="text">内容</span>
            <span class="line"></span>
          </li>
          <li :class="{'item flex align-items':showStep === 1,'item flex align-items current':showStep === 2,'item flex align-items already':showStep === 3}">
            <span class="num">2</span>
            <span class="text">订单</span>
            <span class="line"></span>
          </li>
          <li :class="{'item flex align-items':showStep === 1 || showStep === 2,'item flex align-items current':showStep === 3}">
            <span class="num">3</span>
            <span class="text">发布</span>
          </li>
        </ul>
      </div>
      <!--  -->
      <div class="operation" v-if="oneStep">
        <!-- 模板 -->
        <div v-if="insE === 1">
          <!-- 点击预览 -->
          <el-button class="btn" @click="preview">预览</el-button>
          <!-- 点击下一步生成图像 -->
          <el-button class="btn" type="primary" @click="nextStep">下一步</el-button>
        </div>
        <!-- 自定义 -->
        <div v-if="insE === 0">
          <el-button class="btn" @click="previewCustom">预览</el-button>
          <el-button class="btn" type="primary" @click="nextStepCustom">下一步</el-button>
        </div>
      </div>
      <!-- 判断顶部流程按钮 显示内容  -->
      <div class="operation" v-if="twoStep">
        <el-button class="btn" @click="previousStep" v-if="!isPayment">上一步</el-button>
        <el-button type="primary" class="btn" @click="confirmRelease" v-if="isRelease">确认发布</el-button>
        <el-button type="primary" class="btn" @click="confirmRelease" v-if="isAgain">重新发布</el-button>
        <!-- 点击时 如果条件不满足 提示用户 如果条件都满足那么发送请求将值传给后端 并且调用支付接口-->
        <el-button type="primary" class="btn" @click="confirmEpAgent" v-if="isPayment || isEpAgentEdit">确认支付</el-button>
        <el-button type="primary" class="btn" @click="confirmRelease" v-if="isEdit || isAgentEdit || paymentEdit">确认修改</el-button>
      </div>
    </div>
    <div class="operation-main flex" v-show="showStep === 1">
      <div class="order-content">
        <div class="tit">模板内容</div>
        <!-- 1内容 左侧模板  节点操作-->
        <div class="con">
          <!-- 点击右侧绑定内容 -->
          <order-template
                  @func="getNum"
                  ref="OrderTemplate"
                  :propaganda="propaganda"
                  :education="education"
                  :recruitment="recruitment"
                  :restaurant="restaurant"
                  :automobile="automobile"
                  :insE="insE"
                  :ins="ins"></order-template>
          <div class="ql-container ql-snow" v-if="insE === 0" style="border:none;">
            <div class="ql-editor">
              <div v-html="form.task_content" class="custom-con"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-select">
        <div class="div-box global">
          <span class="tit">全局设置</span>
          <!-- 点击  还原模板内容 重置 -->
          <span class="reset" @click="resetAll"><i class="el-icon-refresh"></i>全局重置为默认</span>
        </div>
        <div class="div-box flex align-items">
          <span class="tit">编辑方式：</span>
          <ul class="ul-box select flex">
            <!-- 判断显示 -->
            <li :class="{active:insE === 1}" @click="editSelect(1)"><span>模版（推荐）</span></li>
            <li :class="{active:insE === 0}" @click="editSelect(0)"><span>自定义</span></li>
          </ul>
        </div>
        <div v-if="this.insE === 1">
          <div class="div-box flex align-items">
            <span class="tit">当前模板：</span>
            <ul class="ul-box flex">
              <!-- 循环模板样式 点击的时候渲染在左侧 -->
              <li v-for="(item,index) in templateType" :class="{active:index===ins}" :key="index" @click="templateSelect(index)"><span>{{item.name}}</span></li>
            </ul>
          </div>
<!--          <div class="div-box flex align-items">-->
<!--            <span class="tit">范围框：</span>-->
<!--            <ul class="ul-box flex">-->
<!--              <li class="active"><span>显示</span></li>-->
<!--              <li><span>隐藏</span></li>-->
<!--            </ul>-->
<!--          </div>-->
            <!-- 提示用户编辑内容区域  点击隐藏 -->
          <div class="edit-box" v-show="!getData">
            <div class="default-show flex justify-content flex-wrap align-items">
              <p class="icon"><img src="@/assets/images/default-show-icon.jpg"></p>
              <p class="click">←点击需要修改的区域，即可修改内容</p>
              <p class="tips">（鼠标移过带虚线框的区域才可以进行修改哟）</p>
            </div>
          </div>
          <!-- 修改内容模板  点击上方提示区域 显示 -->
          <div v-show="isText" class="edit-box">
            <div class="already-select">文本框（已选中）</div>
              <div class="image-size margin-top-20">文字建议：根据左边的预览内容效果来调整字数</div>
            <div class="flex margin-top-20">
              <div class="left-text">文本内容：</div>
              <!-- 绑定内容 -->
              <el-input
                      class="text-box"
                      type="textarea"
                      :rows="6"
                      resize="none"
                      v-model="templateText">
              </el-input>
            </div>
            <!-- 修改内容模板下方 点击还原模板默认内容 -->
            <div class="flex margin-top-20">
              <div class="left-text">辅助功能：</div>
              <div class="reset-default" @click="resetDefault"><i class="el-icon-refresh-right"></i> 重置为默认</div>
            </div>
          </div>
          <!-- 拖拽上传图片 -->
          <div class="edit-box" v-show="isPic">
            <div class="already-select">图片（已选中）</div>
            <div class="image-size margin-top-20">建议尺寸：{{picSize}}，文件不大于300kb</div>
            <div class="flex margin-top-20" style="width: 100%;">
              <div class="left-text">图片上传：</div>
              <el-upload
                      class="upload-demo"
                      drag
                      :before-upload="beforeUpload"
                      :action="upDataImageUrl"
                      :on-success="handleSuccess"
                      :data="uploadImgData">
                <i class="upload-icon"><img src="@/assets/images/upload-icon.jpg"></i>
                <div class="el-upload__text">
                  <p class="textA">点击或将图片拖拽到这里上传</p>
                  <p class="textB">只能上传jpg/png文件</p>
                </div>
              </el-upload>
            </div>
            <!-- 点击还原默认内容 -->
            <div class="flex margin-top-20">
              <div class="left-text">辅助功能：</div>
              <div class="reset-default" @click="resetDefault"><i class="el-icon-refresh-right"></i> 重置为默认</div>
            </div>
            <!--          <img :src="uploadImage">-->
          </div>
        </div>
        <!-- 自定义模版-->
        <div v-if="insE === 0" class="custom-box">
          <el-upload
                  v-show="false"
                  id="avatar-uploader"
                  class="avatar-uploader"
                  :action="upDataFile"
                  name="file"
                  :data="uploadData"
                  :show-file-list="false"
                  :on-success="uploadImgSuccess"
                  :on-error="uploadImgError"
                  :before-upload="beforeUploadImg"
          ></el-upload>
          <el-row v-loading="quillUpdateImg">
            <el-col :span="2"></el-col>
            <el-col :span="22">
              <quill-editor
                      v-model="form.task_content"
                      ref="myQuillEditor"
                      :options="editorOption"
                      @change="onEditorChange($event)"
                      @ready="onEditorReady($event)"
              ></quill-editor>
            </el-col>
          </el-row>
        </div>
        <!--自定义-->
      </div>
      <!--order-select end-->
    </div>
    <!--编辑内容end-->
    <!-- 订单设置模板 -->
    <div v-if="showStep === 2">
      <div class="stepTitle">订单设置</div>
      <el-dialog
              title="请使用微信扫码支付"
              :visible.sync="dialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              center
              :before-close="handleClose"
              width="400px">
        <div class="dialogCode">
          <qriously :value="code_url" :size="250" />
        </div>
        <p class="paymentTips" v-if="!isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
        <p class="alreadyPaymentTips" v-if="isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
      </el-dialog>
      <el-form ref="epForm" :model="form" label-width="100px" class="formBox">
        <el-form-item prop="task_title" label="订单标题">
          <el-input v-model="form.task_title" placeholder="请输入推广标题，限6-20个汉字" style="width: 500px" maxlength="20"  show-word-limit></el-input>
        </el-form-item>
        <!--        <el-button @click="onon">改变</el-button>-->
        <!--        <div v-html="test"></div>-->
        <el-form-item prop="task_type" label="推广类型">
          <el-select v-model="task_type" placeholder="请选择推广类型" v-if="isRelease">
            <el-option v-for="item in list" :key="item.id" :label="item.type_name" :value="item.id">
            </el-option>
            <!-- <el-option label="人才招聘" value="4">人才招聘</el-option> -->
          </el-select>
          <el-select v-model="task_type" placeholder="请选择推广类型" disabled v-if="isEdit || paymentEdit || isAgain || isAgentEdit || isEpAgentEdit">
            <el-option v-for="item in list" :key="item.id" :label="item.type_name" :value="item.id">
            </el-option>
            <!-- <el-option label="人才招聘" value="4">人才招聘</el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="选择奖励">
          <div v-if="isRelease">
            <div v-if="this.$store.state.rank > 1 && this.$store.state.is_official === 0">
              <div class="reward-type flex align-items" v-if="!task_type || task_type == 1 ||task_type == 2 || task_type == 3">
                <span v-for="(item,index) in rewardType" v-show="index<4" :key="index" @click='setReward(index)' :class="{active:reward_type===index}">{{item.name}}</span>
              </div>
            </div>
            <div v-if="this.$store.state.rank > 1 && this.$store.state.is_official === 1">
              <div class="reward-type flex align-items" v-if="!task_type || task_type == 1 ||task_type == 2 || task_type == 3">
                <span v-for="(item,index) in rewardType" :key="index" @click='setReward(index)' :class="{active:reward_type===index}">{{item.name}}</span>
              </div>
            </div>
            <div v-if="this.$store.state.rank === 1 || this.$store.state.user_type === 1">
              <div class="reward-type flex align-items" v-if="!task_type || task_type == 1 ||task_type == 2 || task_type == 3">
                <span v-for="(item,index) in rewardType" v-show="index<1" :key="index" @click='setReward(index)' :class="{active:reward_type===index}">{{item.name}}</span>
              </div>
            </div>
            <div class="reward-type flex align-items" v-if="task_type == 4">
              <span class="active">赏金</span>
            </div>
          </div>
          <div v-if="isEdit || paymentEdit || isAgain || isAgentEdit || isEpAgentEdit">
            <div v-if="this.$store.state.is_official === 0">
              <div class="reward-type flex align-items no-select" v-if="!task_type || task_type == 1 ||task_type == 2 || task_type == 3">
                <span v-for="(item,index) in rewardType" v-show="index<4" :key="index" :class="{active:reward_type===index}">{{item.name}}</span>
              </div>
            </div>
            <div v-if="this.$store.state.is_official === 1">
              <div class="reward-type flex align-items no-select" v-if="!task_type || task_type == 1 ||task_type == 2 || task_type == 3">
                <span v-for="(item,index) in rewardType" :key="index" :class="{active:reward_type===index}">{{item.name}}</span>
              </div>
            </div>
            <div class="reward-type flex align-items" v-if="task_type == 4 || this.$store.state.user_type === 1">
              <span class="active">赏金</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="" label="选择优惠券" v-if="reward_type === 1">
          <div class="no-reward" v-show="couponDataList.length <= 0">暂无优惠券，请到<router-link to='/enterprise/reward'>奖励管理</router-link>中添加体验卡</div>
          <div v-if="isRelease">
            <div class="reward-list flex flex-wrap" v-show="couponDataList">
              <div v-for="(item,index) in couponDataList" :key="index" @click="setCoupon(index,item.id)" :class="{'item active':index===couponMeal || item.id == relate_id,'item':index!==couponMeal}">
                  <p class="select absolute"><i class="el-icon-check"></i></p>
                  <div class="title ellipsis">{{item.name}}</div>
                  <div class="desc ellipsis">{{item.content}}</div>
                  <div class="time">{{item.start_time}}-{{item.end_time}}</div>
              </div>
            </div>
          </div>
          <div v-if="isEdit || paymentEdit || isAgain || isAgentEdit || isEpAgentEdit">
            <div class="reward-list flex flex-wrap no-select" v-show="couponDataList">
              <div v-for="(item,index) in couponDataList" :key="index" :class="{'item active':index===couponMeal || item.id == relate_id,'item':index!==couponMeal}">
                  <p class="select absolute"><i class="el-icon-check"></i></p>
                  <div class="title ellipsis">{{item.name}}</div>
                  <div class="desc ellipsis">{{item.content}}</div>
                  <div class="time">{{item.start_time}}-{{item.end_time}}</div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="" label="选择体验卡" v-show="reward_type === 2">
          <div class="no-reward" v-if="cardDataList.length <= 0">暂无体验卡，请到<router-link to='/enterprise/reward'>奖励管理</router-link>中添加体验卡</div>
          <div class="reward-list flex flex-wrap" v-show="cardDataList">
              <div v-for="(item,index) in cardDataList" :key="index" @click="setCard(index,item.id)" :class="{'item active':index===cardMeal,'item':index!==cardMeal}">
                  <p class="select absolute"><i class="el-icon-check"></i></p>
                  <div class="title ellipsis">{{item.name}}</div>
                  <div class="desc ellipsis">{{item.content}}</div>
                  <div class="time">{{item.start_time}}-{{item.end_time}}</div>
              </div>
          </div>
        </el-form-item>
        <el-form-item prop="" label="选择实物" v-show="reward_type === 3">
          <div class="no-reward" v-if="goodsDataList.length <= 0">暂无体验卡，请到<router-link to='/enterprise/reward'>奖励管理</router-link>中添加实物</div>
          <div class="reward-list flex flex-wrap" v-show="goodsDataList">
              <div v-for="(item,index) in goodsDataList" :key="index" @click="setGoods(index,item.id)" :class="{'item active':index===goodsMeal,'item':index!==goodsMeal}">
                  <p class="select absolute"><i class="el-icon-check"></i></p>
                  <div class="title ellipsis">{{item.name}}</div>
                  <div class="desc ellipsis">{{item.content}}</div>
                  <div class="time">{{item.start_time}}-{{item.end_time}}</div>
              </div>
          </div>
        </el-form-item>
        <el-form-item prop="" label="奖励抽奖次数" v-show="reward_type === 4 && this.$store.state.is_official === 1">
          <el-input v-model="form.task_price" placeholder="请填写抽奖次数" style="width: 500px" maxlength="20"></el-input>
        </el-form-item>
        <div class="flex">
          <el-form-item prop="receipt_time"  label="订单时间">
            <el-date-picker
                    v-model="form.receipt_time"
                    type="datetime"
                    placeholder="请选择开始时间"
                    format="yyyy-MM-dd HH:mm"
                    @change="handleChange(form.receipt_time)"
                    :picker-options="pickerOptions0">
            </el-date-picker>
            <el-date-picker
                    style="margin-left:10px;"
                    v-model="form.task_time"
                    type="datetime"
                    placeholder="请选择结束日期"
                    format="yyyy-MM-dd HH:mm"
                    @change="handleChangeOver(form.task_time)"
                    :picker-options="pickerOptions1">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item prop="cover_pic"  label="订单封面">
        <div class="imgBox">
              <div class="item-img" v-if="form.cover_img">
                <i class="delIcon el-icon-error" @click="delLogo()"></i>
                <img :src="form.cover_img"/>
              </div>
              <el-upload
                      class="avatar-uploader"
                      :action="upDataImageUrl"
                      name="file"
                      :data="uploadImgData"
                      :show-file-list="true"
                      :on-success="handleLogoSuccess"
                      :before-upload="beforeUpload"
                      v-if="form.cover_img === ''|| form.cover_img == null"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="cover-tips">封面将在首页及任务详情页展示，推荐尺寸350*350px</div>
        </el-form-item>
        <div class="expect">
          <el-tooltip effect="dark">
            <div slot="content" style="line-height: 30px;">点击量：任务开始至结束时，达人转发的推广内容获得的有效点击次数。<br/>价格设置标准：按照0.3元/点击量计算，最低300元/1000点击量起投</div>
            <span>预期点击量<i class="el-icon-warning-outline" style="margin-left:10px;"></i></span>
          </el-tooltip>
        </div>
        <!-- 订单设置 套餐 -->
        <div v-show="price_type === 0">
        <el-form-item prop="task_clicks" label="套餐选择">
          <ul class="set-meal" v-if="isRelease">
            <li v-for="(item,index) in priceList" :class="{active:index===meal}" :key="index" @click="setMeal(index)">
              <p class="select absolute"><i class="el-icon-check"></i></p>
              <p class="num flex align-items justify-content"><span class="uv">uv</span><span>{{item.click}}+</span></p>
              <p class="clicks">预估曝光量{{item.show}}</p>
              <p class="price" v-show="reward_type === 0 || !reward_type">￥{{item.price}}</p>
              <p class="price" v-show="reward_type === 1">{{Math.ceil(item.click/spilt_rule[2].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 2">{{Math.ceil(item.click/spilt_rule[3].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 3">{{Math.ceil(item.click/spilt_rule[4].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 4">{{Math.ceil(item.click/spilt_rule[5].spilt_num)}}名额</p>
            </li>
          </ul>
            <ul class="set-meal" v-if="isEpAgentEdit || isPayment || isAgentEdit || isAgain">
                <li v-for="(item,index) in priceList" :class="{active:index===meal || item.price===form.task_price}" :key="index" @click="setMeal(index)">
                    <p class="select absolute"><i class="el-icon-check"></i></p>
                    <p class="num flex align-items justify-content"><span class="uv">uv</span><span>{{item.click}}+</span></p>
                    <p class="clicks">预估曝光量{{item.show}}</p>
                    <p class="price" v-show="reward_type === 0 || !reward_type">￥{{item.price}}</p>
                    <p class="price" v-show="reward_type === 1">{{Math.ceil(item.click/spilt_rule[2].spilt_num)}}名额</p>
                    <p class="price" v-show="reward_type === 2">{{Math.ceil(item.click/spilt_rule[3].spilt_num)}}名额</p>
                    <p class="price" v-show="reward_type === 3">{{Math.ceil(item.click/spilt_rule[4].spilt_num)}}名额</p>
                    <p class="price" v-show="reward_type === 4">{{Math.ceil(item.click/spilt_rule[5].spilt_num)}}名额</p>
                </li>
            </ul>
          <ul class="set-meal no-select" v-if="isEdit || paymentEdit">
            <li v-for="(item,index) in priceList" :class="{active:item.click===form.task_clicks}" :key="index">
              <p class="select absolute"><i class="el-icon-check"></i></p>
              <p class="num flex align-items justify-content"><span class="uv">uv</span><span>{{item.click}}+</span></p>
              <p class="clicks">预估曝光量{{item.show}}</p>
              <p class="price" v-show="reward_type === 0 || !reward_type">￥{{item.price}}</p>
              <p class="price" v-show="reward_type === 1">{{Math.ceil(item.click/spilt_rule[2].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 2">{{Math.ceil(item.click/spilt_rule[3].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 3">{{Math.ceil(item.click/spilt_rule[4].spilt_num)}}名额</p>
              <p class="price" v-show="reward_type === 4">{{Math.ceil(item.click/spilt_rule[5].spilt_num)}}名额</p>
            </li>
          </ul>
        </el-form-item>
        </div>
        <!--其他推广-->
        <div v-show="price_type === 1 && reward_type === 0">
        <el-form-item prop="task_clicks" label="套餐选择">
          <ul class="set-meal recruit-meal" v-if="isRelease">
            <li v-for="(item,index) in priceList" :class="{active:index===meal}" :key="index" @click="setMeal(index)">
              <p class="select absolute"><i class="el-icon-check"></i></p>
              <p class="num flex align-items justify-content"><span>{{item.click}}份简历</span></p>
              <p class="price">￥{{item.price}}</p>
            </li>
          </ul>
            <ul class="set-meal no-select" v-if="isEpAgentEdit || isPayment || isAgentEdit || isAgain">
                <li v-for="(item,index) in priceList" :class="{active:index===meal || item.price===form.task_price}" :key="index" @click="setMeal(index)">
                    <p class="select absolute"><i class="el-icon-check"></i></p>
                    <p class="num flex align-items justify-content"><span>{{item.click}}+</span></p>
                    <p class="price">￥{{item.price}}</p>
                </li>
            </ul>
          <ul class="set-meal no-select" v-if="isEdit || paymentEdit">
            <li v-for="(item,index) in priceList" :class="{active:item.price===form.task_price}" :key="index">
              <p class="select absolute"><i class="el-icon-check"></i></p>
              <p class="num flex align-items justify-content"><span>{{item.click}}+</span></p>
              <p class="price">￥{{item.price}}</p>
            </li>
          </ul>
        </el-form-item>
        </div>
        <!--招聘推广-->
        <!-- 支付方式 -->
        <el-form-item prop="payment" label="支付方式" style="margin-top:-10px;" v-if="this.$store.state.user_type === 0 && reward_type === 0">
          <ul class="select-payment flex" v-if="isRelease || isAgain || isEpAgentEdit || isPayment">
            <li :class="{'item flex align-items justify-content': showView,'active' : form.payment === 1}" @click="selectPayment(1)"><img src="@/assets/images/wechat-icon.png">微信</li>
            <li :class="{'item flex align-items justify-content': showView,'active' : form.payment === 2}" @click="selectPayment(2)" v-if="this.balance >= this.form.task_price"><img src="@/assets/images/balance-icon.png">余额 {{balance}}</li>
            <li class="item flex align-items justify-content no-balance" v-if="this.balance < this.form.task_price"><img src="@/assets/images/balance-icon.png">余额不足 {{balance}}</li>
          </ul>
          <div class="paid" v-if="isEdit">已支付</div>
        </el-form-item>
        <!-- 代付 -->
        <el-form-item prop="agentEp" label="代付" style="margin-top:-10px;" v-if="this.$store.state.user_type === 1">
          <ul class="epList flex" v-if="!paymentEdit">
            <li v-for="(item,index) in epList" @click="handelClickEpId(item.user_id,index)"  :class="{'active' : index===showEp || item.user_id === xcmini_enterprise_user.user_id}" :key="item.user_id">{{item.name}}</li>
          </ul>
          <div class="paid" v-if="paymentEdit">已支付</div>
        </el-form-item>
      </el-form>
    </div>
    <!--编辑订单-->
    <div v-if="this.showStep === 3" class="order-success">
      <div class="order-success-top">
        <span class="el-icon-success"></span>
        <h3>已发布</h3>
        <h4 v-if="this.$store.state.user_type === 0">订单已成功发布，请等待审核通过</h4>
        <h4 v-if="this.$store.state.user_type === 1">订单已成功发布，请等待企业付款</h4>
      </div>
      <div class="order-success-con">
        <p class="title">{{orderTaskTitle}}</p>
        <p class="order-id">订单ID：{{orderTaskSn}}</p>
        <ul class="order-step">
          <li class="item flex align-items">
            <p class="flex align-items">
              <span class="circular"></span>
              <span class="line"></span>
            </p>
            <p class="flex align-items already">
              <span class="circular"></span>
              <span class="line no"></span>
            </p>
            <p class="flex align-items">
              <span class="circular no-c"></span>
            </p>
          </li>
        </ul>
        <ul class="order-step-text relative">
          <li class="item absolute">
            <p class="text">发布订单</p>
            <p class="time">{{orderCreateTime}}</p>
          </li>
          <li class="item absolute">
            <p class="text">审核中</p>
          </li>
          <li class="item absolute">
            <p class="text">发布成功</p>
          </li>
        </ul>
      </div>
      <div class="order-success-btn flex justify-content">
        <el-button type="primary" @click="goToHome" v-if="this.$store.state.user_type === 0">返回首页</el-button>
        <el-button type="primary" @click="goToDarenHome" v-if="this.$store.state.user_type === 1">返回首页</el-button>
        <el-button @click="previewCode">预览</el-button>
      </div>
    </div>
    <!--成功发布-->
  </div>
</template>
<script>
import {
  imgUpload,
  taskType,
  priceType,
  epTaskAdd,
  payWeChat,
  payBalance,
  payResult,
  epInfo,
  epOrderDetail,
  getAgentEp,
  taskEdit,
  UpdateTask,
  couponList,
  experienceCardList,
  goodsList,
  updateConfig,
  checkTaskNum
} from '@/config/api.js'
import axios from 'axios'
import OrderTemplate from '@/components/OrderTemplate'
// 工具栏配置 右侧
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],

  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["image"],
  ["video"],
  ["clean"]
];
export default {
  name: 'Release',
  inject:['showMobileA'],
  components: {
    OrderTemplate
  },
  props: {
    editId:String, //编辑订单id
    orderType:String, //编辑订单type
    agentEpId:String, //编辑订单id
    agentUserId:String, //达人代客编辑订单企业id
    isRelease:Boolean, //发布
    isDarenRelease:Boolean, //发布
    isEdit:Boolean, //编辑
    paymentEdit:Boolean, //站长已支付订单编辑
    isEpAgentEdit:Boolean, //企业代客订单编辑
    isAgentEdit:Boolean, //代客
    isAgain:Boolean, //再次下单
    isPayment:Boolean, //付款
  },
  data () {
    return {
      form: {
        task_title: '',
        task_content: '',//订单内容
        receipt_time: '',//订单开始时间
        task_time: '',//订单结束时间
        task_price: null,//订单价格
        task_clicks: '',
        task_show: '',
        payment: '',
        cover_img: ''
      },
      task_type: '',//订单类型
      couponDataList: [],//优惠券列表
      cardDataList:[],//体验卡列表
      goodsDataList:[],//体验卡列表
      relate_id: '',//奖励关联ID
      couponMeal: '',
      cardMeal: '',
      goodsMeal: '',
      price_type: 0,
      spilt_rule: [],
      status: '',
      templateType: [
        {name: '宣传推广'},
        {name: '教育培训'},
        {name: '人才招聘'},
        {name: '餐饮美食'},
        {name: '房产汽车'},
      ],
      rewardType: [
        {id:'0',name: '赏金'},
        {id:'1',name: '优惠券'},
        {id:'2',name: '体验卡'},
        {id:'3',name: '实物'},
        {id:'4',name: '平台抽奖'}
      ],
      reward_type:'',
      templateText: '',
      ins:0, //模版id 0-宣传推广 1-教育培训 2-人才招聘 3-餐饮美食 4-房产汽车
      insE:1, //编辑类型 0-自定义 1-模版
      meal: '',
      isText: false,
      isPic: false,
      oneStep: true,
      twoStep: false,
      showView: true,
      showStep: 1,
      uploadImage: '',
      upDataImageUrl: imgUpload, //上传图片url
      editType: '',
      templateData: '',
      epList: [],
      releaseType: 1,
      // agentEpId: null,
      showEp: '',
      is_pay: '',
      xcmini_enterprise_user:{},
      picSize: '640*320px',
      timer: null,
      paymentTips: '订单未支付',
      isOrderPayment: false,
      // 模板内容
      propaganda: {
        form1: 'https://img.xiaochengdaren.com/2019112146471.jpg',
        form2: '2019.10.01-2019.11.11',
        form3: '小城周年庆',
        form4: '此处为利益点文案',
        form5: '活动介绍',
        form6: '1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。\n2.活动总要指向一定的对象。\n3.对象有两种:①制约着活动的客观事物；②调节活动的客观事物的心理映象。离开对象的活动是不存在的。',
        form7: '活动奖励',
        form8: 'https://img.xiaochengdaren.com/2019112319521.jpg',
        form9: 'https://img.xiaochengdaren.com/2019112319521.jpg',
        form10: '1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。\n2.活动总要指向一定的对象。\n3.对象有两种:①制约着活动的客观事物；②调节活动的客观事物的心理映象。离开对象的活动是不存在的。',
        form11: '“活动规则”',
        form12: '1. 活动时间：2018年1月25日—2018年2月9日（在活动时间内，活动资源送完则活动自动结束）；\n2. 参与方式：在“浙江移动”微信公众号中回复“福袋”关键字； \n3. 活动规则：用户在活动期间参与活动，可通过本人参与、受邀、邀请好友三种方式参与活动，每个手机号累计最多获得11个福袋。',
        form13: 'https://img.xiaochengdaren.com/2019112319521.jpg',
        form14: '4.活动所得话费券不可拆分、不可转赠、不可兑换现金、不提供发票，需要在60天内到“浙江移动手机营业厅”APP中兑换才可到账，请在截止日期之前兑换使用，过期自动失效；话费券兑换路径：浙江移动手机营业厅>我的>话费券；兑换成功后话费将自动充入您的个人通信馈赠金账户，充入的金额不提供发票；',
        form15: '联系我们',
        form16: '客服电话：5215621321321\n接听时段：周一至周日\n在线咨询时段：9:00-24:00，节假日除外\n邮箱：23321654321354321@qq.com',
        form17: '本活动最终解释权归小城达人所有，如有问题请联系19128188497'
      },
      education:{
        form18:'https://img.xiaochengdaren.com/2019112706236.jpg',
        form19:'一支画笔\n开启\n你的\n漫画世界',
        form20:'小城漫画全能班1期·火热招生中',
        form21:'截止时间：2019.12.31 23:59',
        form22:'你也一定有这样的经历',
        form23:'1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form24:'课程亮点',
        form25:'https://img.xiaochengdaren.com/2019112757121.png',
        form26:'学员喜报',
        form27:'1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form28:'课程大纲',
        form29:'1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form30:'超人气名师',
        form31:'https://img.xiaochengdaren.com/2019112782971.jpg',
        form32:'作品精选',
        form33:'https://img.xiaochengdaren.com/2019112715440.jpg',
        form34:'学生评价',
        form35:'1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form36:'听课须知',
        form37:'1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
      },
      recruitment: {
        form38: '帮啦跑腿招聘',
        form39: 'https://img.xiaochengdaren.com/2019112746952.jpg',
        form40: '广州帮啦招聘',
        form41: '3大岗位●热招中',
        form42: '企业简介',
        form43: '广东帮啦网络科技有限公司',
        form44: '帮啦是O2O+互联网模式新零售与即时配送的公司，全国已开通超过100+直营与加盟联营城市。帮啦自身拥有强大的运营与技术团队，其中技术团队超过30+人，通过自主研发最新的互联网技术，整合社会专职和闲置优质人力为企业、商家、消费者提供专业，安全，高效的同城生活服务与物流配送业务。',
        form45: '企业环境',
        form46: 'https://img.xiaochengdaren.com/2019112728838.jpg',
        form47: 'https://img.xiaochengdaren.com/2019112728838.jpg',
        form48: 'https://img.xiaochengdaren.com/2019112728838.jpg',
        form49: '岗位',
        form50: '广州帮啦招聘',
        form51: '3大岗位●热招中',
        form52: '销售精英',
        form53: '大专以上学历，2年以上相关软件销售或大型项目式销售的工作经验；具有较强的内驱力、沟通能力、关系建立能力；心智成熟、有责任意识、抗压能力强、积极热情、吃苦耐劳；熟悉当地市场，或具备该地域制造行业或管理软件销售经验者优先',
        form54: '市场运营',
        form55: '大专以上学历，2年以上相关软件销售或大型项目式销售的工作经验；具有较强的内驱力、沟通能力、关系建立能力；心智成熟、有责任意识、抗压能力强、积极热情、吃苦耐劳；熟悉当地市场，或具备该地域制造行业或管理软件销售经验者优先',
        form56: '在线客服',
        form57: '大专以上学历，2年以上相关软件销售或大型项目式销售的工作经验；具有较强的内驱力、沟通能力、关系建立能力；心智成熟、有责任意识、抗压能力强、积极热情、吃苦耐劳；熟悉当地市场，或具备该地域制造行业或管理软件销售经验者优先',
        form58: '工作地点',
        form59: '技术部：广州海珠区（ps:窗口可以直接看到广州塔哦0w0~）\n（ps:窗口可以直接看到广州塔哦0w0~）',
        form60: '投递方式',
        form61: '请将简历发送至“ blpt@163.vip.com ”\n（ps:备注应聘岗位，三个工作日内回复）',
        form62: 'https://img.xiaochengdaren.com/2019112791916.jpg',
        form63: '关注“帮啦跑腿”公众号\n了解更多招聘资讯',
      },
      restaurant: {
        form64: 'https://img.xiaochengdaren.com/2019112721284.jpg',
        form65: '帮啦食府·开业大促',
        form66: '吃货看这里',
        form67: '10.31-11.11 全店5折起',
        form68: '一重礼·半价招牌菜',
        form69: 'https://img.xiaochengdaren.com/2019112715186.jpg',
        form70: '二重礼·点单就送果盘',
        form71: '1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form72: 'https://img.xiaochengdaren.com/2019112823387.jpg',
        form73: '三重礼·满额送优惠券',
        form74: '1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form75: '四重礼·编不下去了',
        form76: '1.活动和动作都是以实现预定目的为特征的，但是动作受单一目的的制约。而活动则受一种完整的目的和动机系统的制约。活动是由一系列动作构成的系统。',
        form77: 'https://img.xiaochengdaren.com/2019112823387.jpg',
        form78: '店内环境',
        form79: 'https://img.xiaochengdaren.com/2019112867084.jpg',
        form80: 'https://img.xiaochengdaren.com/2019112867084.jpg',
        form81: 'https://img.xiaochengdaren.com/2019112867084.jpg',
        form82: '联系我们',
        form83: '订餐热线：020-5215621门店地址：广州市海珠区好运商务大厦1303公众号：搜索',
        form84: '本活动最终解释权归小城达人所有，如有问题请联系“xxxxxxxxx”',
      },
      automobile: {
        form85: 'https://img.xiaochengdaren.com/2019112815161.jpg',
        form86: 'Model 3\n双电机·全轮驱动',
        form87: 'https://img.xiaochengdaren.com/2019112854227.jpg',
        form88: '设计以安全为先',
        form89: 'Model 3 Performance 版搭载双电机全轮驱动、19 英寸轮毂和高级制动系统，悬架高度更低，在绝大部分天气条件下都拥有极佳的操控体验。',
        form90: 'https://img.xiaochengdaren.com/2019112805520.jpg',
        form91: 'https://img.xiaochengdaren.com/2019112816958.jpg',
        form92: '卓越的加速性能',
        form93: 'Model 3 Performance 版搭载双电机全轮驱动、19 英寸轮毂和高级制动系统，悬架高度更低，在绝大部分天气条件下都拥有极佳的操控体验。',
        form94: 'https://img.xiaochengdaren.com/2019112848164.jpg',
        form95: 'https://img.xiaochengdaren.com/2019112848164.jpg',
        form96: '全轮驱动双电机',
        form97: 'Model 3 Performance 版搭载双电机全轮驱动、19 英寸轮毂和高级制动系统，悬架高度更低，在绝大部分天气条件下都拥有极佳的操控体验。',
        form98: '续航里程\n不断扩展的充电网络',
        form99: 'Model 3 Performance 版搭载双电机全轮驱动、19 英寸轮毂和高级制动系统，悬架高度更低，在绝大部分天气条件下都拥有极佳的操控体验。',
        form100: 'https://img.xiaochengdaren.com/2019112820228.jpg',
        form101: '联系我们',
        form102: '24小时售后热线：020-54313153213132门店地址：广州市海珠区好运商务大厦1303公众号：搜索',
      },
      orderTaskTitle: '',
      orderTaskSn: '',
      orderTaskUrl: '',
      orderCreateTime: '',
      getData:null,
      htmlUrl: '',
      templatePic: '',
      uploadImgData: {
        entry_type: 'web',
        file: 'binary'
      },
      startTime:new Date(2000, 10, 10, 10, 10),
      code_url: '',
      isClick: false,
      radio1: '',
      radio2: '',
      list: [],
      money: null,
      balance:null, //账户余额
      priceList: [], //订单设置套餐
      pickerOptions0: {//结束时间不能大于开始时间
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7

        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let date = new Date(this.form.receipt_time);
          return time.getTime() < date.getTime() - 8.64e7 || time.getTime() > date.getTime() + 5 * 24 * 60 * 60 * 1000;
        }
      },
      dialogVisible: false,
      dialogCode: false,
      upDataFile: imgUpload,
      quillUpdateImg: false,
      uploadData: {
        entry_type: 'web',
        file: 'binary'
      },
      task_content: '',
      editorOption: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector("#avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      } // 富文本编辑器配置
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    mobileContent () {
      return this.$store.state.mobileCon
    }
  },
  provide(){
    return{
      lssueOrder:this.lssueOrder,
      nextStepSuccess:this.nextStepSuccess
    }
  },
  methods: {
    // 点击模板 索引
    templateSelect (index) {
      // 显示
      this.ins=index;
      this.getData = '';
      this.isText = false;
      this.isPic = false;
    },
    // 当inse等于0 显示模板预览，下一步的按钮 等于1显示自定义预览下一步的按钮
    editSelect (index) {
      this.insE=index
    },
    nextStep () {
      // 导入图像
      this.$refs.OrderTemplate.toImage();
      // localStorage.showStep = 2;
    },
    nextStepSuccess () {
      this.oneStep = !this.oneStep;
      this.twoStep = !this.twoStep;
      this.showStep = 2;
      this.agentEpList()
    },
    agentEpList () {
      let data = {
        agent_id: this.$store.state.user_id
      };
      this.$post(getAgentEp,data)
              .then(res => {
                this.epList = res.data
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    // 代付

    handelClickEpId  (id,index) {
      this.agentEpId = id;
      this.showEp = index;
      this.xcmini_enterprise_user.user_id = id
    },
    nextStepCustom () {
      this.showLoading();
      setTimeout( () => {
        this.oneStep = !this.oneStep;
        this.twoStep = !this.twoStep;
        this.showStep = 2;
        // localStorage.showStep = this.showStep;
        this.hideLoading();
        this.agentEpList();
      },1000)
    },
    previousStep () {
      this.oneStep = !this.oneStep;
      this.twoStep = !this.twoStep;
      this.showStep = 1;
      // localStorage = 1;
    },
    getNum (index,form,type) {
      // window.console.log(type);
      this.editType = type;
      this.getData = index;
      if (this.editType === 'text') {
        this.isText = true;
        this.isPic = false;
        this.templateText = form;
      } else if (this.editType === 'pic') {
        this.isText = false;
        this.isPic = true;
        if (form === this.propaganda.form1) {
            this.picSize = '85*85px，PNG透明图片'
        } else if (form === this.education.form18) {
          this.picSize = '240*80px，PNG透明图片'
        } else if (form === this.restaurant.form64) {
          this.picSize = '100*100px，PNG透明图片'
        } else if (form === this.automobile.form85) {
          this.picSize = '240*80px，PNG透明图片'
        } else {
            this.picSize = '图片宽高自定义'
        }
      }
    },
    handleSuccess(res) {
      this.$message.success('上传成功');
      this.uploadImage = res.task_img;
      switch (this.getData) {
          case 1:
          this.propaganda.form1 = res.task_img;
          break;
        case 8:
          this.propaganda.form8 = res.task_img;
          break;
        case 9:
          this.propaganda.form9 = res.task_img;
          break;
        case 13:
          this.propaganda.form13 = res.task_img;
          break;
        case 18:
          this.education.form18 = res.task_img;
          break;
        case 25:
          this.education.form25 = res.task_img;
          break;
        case 31:
          this.education.form31 = res.task_img;
          break;
        case 33:
          this.education.form33 = res.task_img;
          break;
        case 39:
          this.recruitment.form39 = res.task_img;
          break;
        case 46:
          this.recruitment.form46 = res.task_img;
          break;
        case 47:
          this.recruitment.form47 = res.task_img;
          break;
        case 48:
          this.recruitment.form48 = res.task_img;
          break;
        case 62:
          this.recruitment.form62 = res.task_img;
          break;
        case 64:
          this.restaurant.form64 = res.task_img;
          break;
        case 69:
          this.restaurant.form69 = res.task_img;
          break;
        case 72:
          this.restaurant.form72 = res.task_img;
          break;
        case 77:
          this.restaurant.form77 = res.task_img;
          break;
        case 79:
          this.restaurant.form79 = res.task_img;
          break;
        case 80:
          this.restaurant.form80 = res.task_img;
          break;
        case 81:
          this.restaurant.form81 = res.task_img;
          break;
        case 85:
          this.automobile.form85 = res.task_img;
          break;
        case 90:
          this.automobile.form90 = res.task_img;
          break;
        case 91:
          this.automobile.form91 = res.task_img;
          break;
        case 94:
          this.automobile.form94 = res.task_img;
          break;
        case 95:
          this.automobile.form95 = res.task_img;
          break;
        case 100:
          this.automobile.form100 = res.task_img;
          break;
      }
    },
    // 还原模板内容 重置
    resetAll () {
      this.showLoading();
      setTimeout( () => {
        switch (this.ins) {
          case 0:
            this.propaganda = this.$options.data().propaganda;
            break;
          case 1:
            this.education = this.$options.data().education;
            break;
          case 2:
            this.recruitment = this.$options.data().recruitment;
            break;
          case 3:
            this.restaurant = this.$options.data().restaurant;
            break;
          case 4:
            this.automobile = this.$options.data().automobile;
            break;
        }
        this.$refs.OrderTemplate.isShow();
        this.getData = '';
        this.isText = false;
        this.isPic = false;
        this.hideLoading();
        this.$message.success('全局已经重置为默认')
      },1000)
    },
    // 还原默认方法 值=默认模板内容区域 还原为默认内容
    resetDefault () {
      switch (this.getData) {
        case 1:
          this.propaganda.form1 = this.$options.data().propaganda.form1;
          break;
        case 2:
          this.propaganda.form2 = this.$options.data().propaganda.form2;
          this.templateText = this.propaganda.form2;
          break;
        case 3:
          this.propaganda.form3 = this.$options.data().propaganda.form3;
          this.templateText = this.propaganda.form3;
          break;
        case 4:
          this.propaganda.form4 = this.$options.data().propaganda.form4;
          this.templateText = this.propaganda.form4;
          break;
        case 5:
          this.propaganda.form5 = this.$options.data().propaganda.form5;
          this.templateText = this.propaganda.form5;
          break;
        case 6:
          this.propaganda.form6 = this.$options.data().propaganda.form6;
          this.templateText = this.propaganda.form6;
          break;
        case 7:
          this.propaganda.form7 = this.$options.data().propaganda.form7;
          this.templateText = this.propaganda.form7;
          break;
        case 8:
          this.propaganda.form8 = this.$options.data().propaganda.form8;
          break;
        case 9:
          this.propaganda.form9 = this.$options.data().propaganda.form9;
          break;
        case 10:
          this.propaganda.form10 = this.$options.data().propaganda.form10;
          this.templateText = this.propaganda.form10;
          break;
        case 11:
          this.propaganda.form11 = this.$options.data().propaganda.form11;
          this.templateText = this.propaganda.form11;
          break;
        case 12:
          this.propaganda.form12 = this.$options.data().propaganda.form12;
          this.templateText = this.propaganda.form12;
          break;
        case 13:
          this.propaganda.form13 = this.$options.data().propaganda.form13;
          break;
        case 14:
          this.propaganda.form14 = this.$options.data().propaganda.form14;
          this.templateText = this.propaganda.form14;
          break;
        case 15:
          this.propaganda.form15 = this.$options.data().propaganda.form15;
          this.templateText = this.propaganda.form15;
          break;
        case 16:
          this.propaganda.form16 = this.$options.data().propaganda.form16;
          this.templateText = this.propaganda.form16;
          break;
        case 17:
          this.propaganda.form17 = this.$options.data().propaganda.form17;
          this.templateText = this.propaganda.form17;
          break;
        case 18:
          this.education.form18 = this.$options.data().education.form18;
          break;
        case 19:
          this.education.form19 = this.$options.data().education.form19;
          this.templateText = this.education.form19;
          break;
        case 20:
          this.education.form20 = this.$options.data().education.form20;
          this.templateText = this.education.form20;
          break;
        case 21:
          this.education.form21 = this.$options.data().education.form21;
          this.templateText = this.education.form21;
          break;
        case 22:
          this.education.form22 = this.$options.data().education.form22;
          this.templateText = this.education.form22;
          break;
        case 23:
          this.education.form23 = this.$options.data().education.form23;
          this.templateText = this.education.form23;
          break;
        case 24:
          this.education.form24 = this.$options.data().education.form24;
          this.templateText = this.education.form24;
          break;
        case 25:
          this.education.form25 = this.$options.data().education.form25;
          break;
        case 26:
          this.education.form26 = this.$options.data().education.form26;
          this.templateText = this.education.form26;
          break;
        case 27:
          this.education.form27 = this.$options.data().education.form27;
          this.templateText = this.education.form27;
          break;
        case 28:
          this.education.form28 = this.$options.data().education.form28;
          this.templateText = this.education.form28;
          break;
        case 29:
          this.education.form29 = this.$options.data().education.form29;
          this.templateText = this.education.form29;
          break;
        case 30:
          this.education.form30 = this.$options.data().education.form30;
          this.templateText = this.education.form30;
          break;
        case 31:
          this.education.form31 = this.$options.data().education.form31;
          break;
        case 32:
          this.education.form32 = this.$options.data().education.form32;
          this.templateText = this.education.form32;
          break;
        case 33:
          this.education.form33 = this.$options.data().education.form33;
          break;
        case 34:
          this.education.form34 = this.$options.data().education.form34;
          this.templateText = this.education.form34;
          break;
        case 35:
          this.education.form35 = this.$options.data().education.form35;
          this.templateText = this.education.form35;
          break;
        case 36:
          this.education.form36 = this.$options.data().education.form36;
          this.templateText = this.education.form36;
          break;
        case 37:
          this.education.form37 = this.$options.data().education.form37;
          this.templateText = this.education.form37;
          break;
        case 38:
          this.recruitment.form38 = this.$options.data().recruitment.form38;
          this.templateText = this.recruitment.form38;
          break;
        case 39:
          this.recruitment.form39 = this.$options.data().recruitment.form39;
          break;
        case 40:
          this.recruitment.form40 = this.$options.data().recruitment.form40;
          this.templateText = this.recruitment.form40;
          break;
        case 41:
          this.recruitment.form41 = this.$options.data().recruitment.form41;
          this.templateText = this.recruitment.form41;
          break;
        case 42:
          this.recruitment.form42 = this.$options.data().recruitment.form42;
          this.templateText = this.recruitment.form42;
          break;
        case 43:
          this.recruitment.form43 = this.$options.data().recruitment.form43;
          this.templateText = this.recruitment.form43;
          break;
        case 44:
          this.recruitment.form44 = this.$options.data().recruitment.form44;
          this.templateText = this.recruitment.form44;
          break;
        case 45:
          this.recruitment.form45 = this.$options.data().recruitment.form45;
          this.templateText = this.recruitment.form45;
          break;
        case 46:
          this.recruitment.form46 = this.$options.data().recruitment.form46;
          break;
        case 47:
          this.recruitment.form47 = this.$options.data().recruitment.form47;
          break;
        case 48:
          this.recruitment.form48 = this.$options.data().recruitment.form48;
          break;
        case 49:
          this.recruitment.form49 = this.$options.data().recruitment.form49;
          this.templateText = this.recruitment.form49;
          break;
        case 50:
          this.recruitment.form50 = this.$options.data().recruitment.form50;
          this.templateText = this.recruitment.form50;
          break;
        case 51:
          this.recruitment.form51 = this.$options.data().recruitment.form51;
          this.templateText = this.recruitment.form51;
          break;
        case 52:
          this.recruitment.form52 = this.$options.data().recruitment.form52;
          this.templateText = this.recruitment.form52;
          break;
        case 53:
          this.recruitment.form53 = this.$options.data().recruitment.form53;
          this.templateText = this.recruitment.form53;
          break;
        case 54:
          this.recruitment.form54 = this.$options.data().recruitment.form54;
          this.templateText = this.recruitment.form54;
          break;
        case 55:
          this.recruitment.form55 = this.$options.data().recruitment.form55;
          this.templateText = this.recruitment.form55;
          break;
        case 56:
          this.recruitment.form56 = this.$options.data().recruitment.form56;
          this.templateText = this.recruitment.form56;
          break;
        case 57:
          this.recruitment.form57 = this.$options.data().recruitment.form57;
          this.templateText = this.recruitment.form57;
          break;
        case 58:
          this.recruitment.form58 = this.$options.data().recruitment.form58;
          this.templateText = this.recruitment.form58;
          break;
        case 59:
          this.recruitment.form59 = this.$options.data().recruitment.form59;
          this.templateText = this.recruitment.form59;
          break;
        case 60:
          this.recruitment.form60 = this.$options.data().recruitment.form60;
          this.templateText = this.recruitment.form60;
          break;
        case 61:
          this.recruitment.form61 = this.$options.data().recruitment.form61;
          this.templateText = this.recruitment.form61;
          break;
        case 62:
          this.recruitment.form62 = this.$options.data().recruitment.form62;
          break;
        case 63:
          this.recruitment.form63 = this.$options.data().recruitment.form63;
          this.templateText = this.recruitment.form63;
          break;
        case 64:
          this.recruitment.form64 = this.$options.data().recruitment.form64;
          break;
        case 65:
          this.restaurant.form65 = this.$options.data().restaurant.form65;
          this.templateText = this.restaurant.form65;
          break;
        case 66:
          this.restaurant.form66 = this.$options.data().restaurant.form66;
          this.templateText = this.restaurant.form66;
          break;
        case 67:
          this.restaurant.form67 = this.$options.data().restaurant.form67;
          this.templateText = this.restaurant.form67;
          break;
        case 68:
          this.restaurant.form68 = this.$options.data().restaurant.form68;
          this.templateText = this.restaurant.form68;
          break;
        case 69:
          this.restaurant.form69 = this.$options.data().restaurant.form69;
          break;
        case 70:
          this.restaurant.form70 = this.$options.data().restaurant.form70;
          this.templateText = this.restaurant.form70;
          break;
        case 71:
          this.restaurant.form71 = this.$options.data().restaurant.form71;
          this.templateText = this.restaurant.form71;
          break;
        case 72:
          this.restaurant.form72 = this.$options.data().restaurant.form72;
          break;
        case 73:
          this.restaurant.form73 = this.$options.data().restaurant.form73;
          this.templateText = this.restaurant.form73;
          break;
        case 74:
          this.restaurant.form74 = this.$options.data().restaurant.form74;
          this.templateText = this.restaurant.form74;
          break;
        case 75:
          this.restaurant.form75 = this.$options.data().restaurant.form75;
          this.templateText = this.restaurant.form75;
          break;
        case 76:
          this.restaurant.form76 = this.$options.data().restaurant.form76;
          this.templateText = this.restaurant.form76;
          break;
        case 77:
          this.restaurant.form77 = this.$options.data().restaurant.form77;
          break;
        case 78:
          this.restaurant.form78 = this.$options.data().restaurant.form78;
          this.templateText = this.restaurant.form78;
          break;
        case 79:
          this.restaurant.form79 = this.$options.data().restaurant.form79;
          break;
        case 80:
          this.restaurant.form80 = this.$options.data().restaurant.form80;
          break;
        case 81:
          this.restaurant.form81 = this.$options.data().restaurant.form81;
          break;
        case 82:
          this.restaurant.form82 = this.$options.data().restaurant.form82;
          this.templateText = this.restaurant.form82;
          break;
        case 83:
          this.restaurant.form83 = this.$options.data().restaurant.form83;
          this.templateText = this.restaurant.form83;
          break;
        case 84:
          this.restaurant.form84 = this.$options.data().restaurant.form84;
          this.templateText = this.restaurant.form84;
          break;
        case 85:
          this.restaurant.form85 = this.$options.data().restaurant.form85;
          break;
        case 86:
          this.automobile.form86 = this.$options.data().automobile.form86;
          this.templateText = this.automobile.form86;
          break;
        case 87:
          this.automobile.form87 = this.$options.data().restaurant.form87;
          break;
        case 88:
          this.automobile.form88 = this.$options.data().automobile.form88;
          this.templateText = this.automobile.form88;
          break;
        case 89:
          this.automobile.form89 = this.$options.data().automobile.form89;
          this.templateText = this.automobile.form89;
          break;
        case 90:
          this.automobile.form90 = this.$options.data().restaurant.form90;
          break;
        case 91:
          this.automobile.form91 = this.$options.data().restaurant.form91;
          break;
        case 92:
          this.automobile.form92 = this.$options.data().automobile.form92;
          this.templateText = this.automobile.form92;
          break;
        case 93:
          this.automobile.form93 = this.$options.data().automobile.form93;
          this.templateText = this.automobile.form93;
          break;
        case 94:
          this.automobile.form94 = this.$options.data().restaurant.form94;
          break;
        case 95:
          this.automobile.form95 = this.$options.data().restaurant.form95;
          break;
        case 96:
          this.automobile.form96 = this.$options.data().automobile.form96;
          this.templateText = this.automobile.form96;
          break;
        case 97:
          this.automobile.form97 = this.$options.data().automobile.form97;
          this.templateText = this.automobile.form93;
          break;
        case 98:
          this.automobile.form98 = this.$options.data().automobile.form98;
          this.templateText = this.automobile.form98;
          break;
        case 99:
          this.automobile.form99= this.$options.data().automobile.form99;
          this.templateText = this.automobile.form99;
          break;
        case 100:
          this.automobile.form100 = this.$options.data().restaurant.form100;
          break;
        case 101:
          this.automobile.form101 = this.$options.data().automobile.form101;
          this.templateText = this.automobile.form101;
          break;
        case 102:
          this.automobile.form102 = this.$options.data().automobile.form102;
          this.templateText = this.automobile.form102;
          break;
      }
    },
    goToHome () {
      this.$router.push('/enterprise/manage')
    },
      goToDarenHome () {
          this.$router.push('/daren/manage')
      },
    getType () {
      axios.get(taskType)
              .then(res => {
                const data = res.data;
                this.list = data.data.list;
              })
    },
    handleChange (value) {
      const valueTime = new Date(Date.parse(value));
      const frontOneHour = new Date(new Date().getTime() + 1 * 60 * 60 * 1000);
      if (new Date().setTime(valueTime) < new Date().setTime(frontOneHour)) {
        this.$message.error('开始时间应该为一个小时后');
        this.form.receipt_time = '';
      }
      this.form.task_time = '';
    },
    handleChangeOver (value) {
      const overTime = new Date(Date.parse(value));
      // window.console.log(overTime);
      const frontOneHour = new Date(Date.parse(this.form.receipt_time));
      // window.console.log(frontOneHour);
      if (new Date().setTime(overTime) <= new Date().setTime(frontOneHour)) {
        this.$message.error('结束时间不能小于或等于开始时间');
        this.form.task_time = '';
      } else if (new Date().setTime(overTime) - new Date().setTime(frontOneHour)  > 5 * 24 * 60 * 60 * 1000) {
        this.$message.error('结束时间不能超过五天');
        this.form.task_time = '';
      }
    },
    changeNum (index) {
      this.form.task_clicks = this.priceList[index].click;
      this.form.task_show = this.priceList[index].show;
      this.isClick = true;
    },
    getPrice () {
      let data = {
        type: this.price_type
      };
      this.$post(priceType,data)
              .then(res => {
                const data = res.data;
                this.priceList = data.list;
                window.console.log(this.priceList)
              })
              .catch(err => {
                window.console.log(err)
              })
      // 获取套餐信息
    },
    confirmRelease () {
      // 订单标题
      if (!this.form.task_title) {
        this.$message.error('请输入标题')
      } else if (this.form.task_title.length < 6) {
        this.$message.error('标题不能少于6个字')
        // 订单类型 task_type  订单开始时间receipt_time 订单结束时间task_time  订单选择套餐task_price 订单支付方式payment
      } else if (!this.task_type) {
        this.$message.error('请选择类型')
        // 订单开始时间
      } else if (this.reward_type.length <= 0) {
        this.$message.error('请选择奖励')
        // 奖励
      } else if (this.reward_type !==0 && !this.relate_id && this.form.task_price <= 0) {
        this.$message.error('请选择优惠券/体验卡/实物/抽奖次数')
      } else if (!this.form.receipt_time) {
        this.$message.error('请选择开始时间')
        // 订单结束时间
      } else if (!this.form.task_time) {
        this.$message.error('请选择结束时间')
        // 订单选择套餐
      } else if (!this.form.cover_img) {
        this.$message.error('请上传封面')
        // 订单开始时间
      } else if (!this.form.task_price) {
        this.$message.error('请选择套餐')
        // 支付方式
      } else if (this.reward_type === 0 && !this.form.payment) {
        this.$message.error('请选择支付方式')
      } else {
        if (!this.agentEpId && this.isDarenRelease) {
          this.$message.error('请选择代付企业')
        } else {
          this.showLoading();
          if (this.insE === 1) {
            this.$refs.OrderTemplate.uploadImageA();
          } else {
            this.lssueOrder()
          }
        }
      }
    },
      confirmEpAgent () {
          if (!this.form.task_title) {
              this.$message.error('请输入标题')
          } else if (this.form.task_title.length < 6) {
              this.$message.error('标题不能少于6个字')
          } else if (!this.task_type) {
              this.$message.error('请选择类型')
          } else if (!this.form.receipt_time) {
              this.$message.error('请选择开始时间')
          } else if (!this.form.task_time) {
              this.$message.error('请选择结束时间')
          } else if (!this.form.payment) {
              this.$message.error('请选择支付方式')
          } else {
            this.showLoading();
            if (this.isPayment) {
              this.EpAgentEdit();
            } else if (this.isEpAgentEdit) {
              if (this.insE === 1) {
                this.$refs.OrderTemplate.uploadImageA();
              } else {
                this.lssueOrder()
              }
            }
          }
      },
    lssueOrder () {
      switch (this.ins) {
        case 0:
          this.templateData = JSON.stringify(this.propaganda);
          break;
        case 1:
          this.templateData = JSON.stringify(this.education);
          break;
        case 2:
          this.templateData = JSON.stringify(this.recruitment);
          break;
        case 3:
          this.templateData = JSON.stringify(this.restaurant);
          break;
        case 4:
          this.templateData = JSON.stringify(this.automobile);
          break;
      }
      if (this.insE === 1) {
        this.form.task_content = '<img src=' + '"' + this.$store.state.templatePic + '"' + '>'
      }
      if (this.$store.state.user_type === 0) {
        if (this.isRelease || this.isAgain) {
          this.EpRelease();
        } else if (this.isEpAgentEdit || this.isPayment) {
          this.EpAgentEdit()
        } else if (this.isEdit || this.paymentEdit) {
          this.epEdit()
        }
      } else if (this.$store.state.user_type === 1) {
        if (this.isRelease || this.isAgain) {
          this.darenRelease();
        } else if (this.paymentEdit) {
          this.epEdit()
        } else if (this.isAgentEdit) {
          this.agentEdit()
        }

      }
    },

    //企业发布订单
    EpRelease () {
      // 订单类型 task_type  订单开始时间receipt_time 订单结束时间task_time  订单选择套餐task_price 订单支付方式payment
      if (this.reward_type === 0 ||  this.reward_type === 4) {
        let data = {
        user_type: this.$store.state.user_type,
        user_id: this.$store.state.user_id,
        task_type: this.task_type, //订单类型
        task_title: this.form.task_title, //订单标题
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,//订单开始时间
        task_time: this.form.task_time, //订单结束时间
        task_price: this.form.task_price, //订单套餐
        task_clicks: this.form.task_clicks,
        task_show: this.form.task_show,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
        type: this.releaseType,
        reward_type: this.reward_type,
        cover_img: this.form.cover_img,
        relate_id: Number(this.relate_id)
      };
      this.$post(epTaskAdd, data)
              .then(res => {
                let data = res.data;
                this.money = data.task_price;
                this.task_sn = data.task_sn;
                this.task_id = data.task_id;
                if (this.form.payment === 1) {
                  //调用微信支付
                  this.weChatPayment()
                }else if (this.form.payment === 2) {
                  //调用余额支付
                  this.balancePayment()
                } else {
                  this.$message.error('没有选择支付方式');
                }
              })
              .catch(() => {
                this.$message.error('很抱歉，发布失败，请重新再试');
                this.hideLoading();
              })
      } else {
        let data = {
        user_type: this.$store.state.user_type,
        user_id: this.$store.state.user_id,
        task_type: this.task_type, //订单类型
        task_title: this.form.task_title, //订单标题
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,//订单开始时间
        task_time: this.form.task_time, //订单结束时间
        task_price: '0.00', //订单套餐
        task_clicks: this.form.task_clicks,
        task_show: this.form.task_show,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
        type: this.releaseType,
        reward_type: this.reward_type,
        cover_img: this.form.cover_img,
        relate_id: Number(this.relate_id)
      };
      this.$post(epTaskAdd, data)
              .then(res => {
                let data = res.data;
                this.money = data.task_price;
                this.task_sn = data.task_sn;
                this.task_id = data.task_id;
                if (this.form.payment === 1) {
                  //调用微信支付
                  this.weChatPayment()
                }else if (this.form.payment === 2) {
                  //调用余额支付
                  this.balancePayment()
                } else {
                  this.$message.error('没有选择支付方式');
                }
              })
              .catch(() => {
                this.$message.error('很抱歉，发布失败，请重新再试');
                this.hideLoading();
              })
      }
      
    },

    EpAgentEdit () {
      // 将值传送给后台
      let data = {
        user_type: 0,
        user_id:this.$store.state.user_id,
        task_id:this.editId,//订单id
        task_type: this.task_type,
        task_title: this.form.task_title,
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,
        task_time: this.form.task_time,
        task_price: this.form.task_price,
        task_clicks: this.form.task_clicks,
        task_show: this.form.task_show,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
      };
      this.$post(UpdateTask,data)
              .then(res => {
                // window.console.log(res);
                  this.task_id = res.data.task_id;
                  this.money = res.data.task_price;
                  this.task_sn = res.data.task_sn;
                if (this.form.payment === 1) {
                  //调用微信支付
                  this.weChatPayment()
                }else if (this.form.payment === 2) {
                  //调用余额支付
                  this.balancePayment()
                }else {
                  this.$message.error('没有选择支付方式');
                }
              })
              .catch(() => {
                this.$message.error('很抱歉，发布失败，请重新再试');
                this.hideLoading();
              })
    },

    //微信支付
    weChatPayment () {
      let data = {
        user_type: 0,
        user_id: this.$store.state.user_id,
        openid: this.$store.state.openid,
        task_id: this.task_id,
        task_sn: this.task_sn,
        task_price: this.money,
      };
      this.$post(payWeChat,data)
              .then(res => {
                this.code_url = res.data.code_url;
                this.dialogVisible = true;
                this.hideLoading();
                this.timer = setInterval( () => {
                  this.paymentResult()
                },2000)
              })
              .catch(err => {
                window.console.log(err);
                this.hideLoading();
                this.$message.error('很抱歉，生成支付失败');
              })
    },

    //余额支付
    balancePayment () {
      let data = {
        user_type: 0,
        user_id: this.$store.state.user_id,
        task_id: this.task_id,
        task_sn: this.task_sn,
        pay_type: 1,
      };
      this.$post(payBalance,data)
              .then(() => {
                // window.console.log(res);
                setTimeout(() => {
                  this.hideLoading();
                  this.$message.success('您已成功发布');
                  this.releaseSuccess()
                  //余额支付成功后跳转详情
                }, 1000);
              })
              .catch(err => {
                  window.console.log(err);
                this.hideLoading();
                setTimeout(() => {
                  this.$message.error('很抱歉，发布失败，请重新再试');
                }, 1000);
              })
    },

    //达人代客下单
    darenRelease () {
      let data = {
        user_type: 0,
        user_id: this.agentEpId,
        task_type: this.task_type,
        task_title: this.form.task_title,
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,
        task_time: this.form.task_time,
        task_price: this.form.task_price,
        task_clicks: this.form.task_clicks,
        task_show: this.form.task_show,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
        is_valet: 1,
        agent_id:this.$store.state.user_id,
        type:this.releaseType,
        cover_img: this.form.cover_img
      };
      this.$post(epTaskAdd, data)
              .then(res => {
                this.$message.success('您已成功发布');
                this.task_id = res.data.task_id;
                this.task_sn = res.data.task_sn;
                this.hideLoading();
                this.releaseSuccess()
                //发布成功后跳转详情
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    releaseSuccess () {
      window.clearInterval(this.timer);
      this.timer = null;
      this.hideLoading();
      //企业发布订单成功
      if (this.$store.state.user_type === 0 && !this.isEpAgentEdit && !this.isPayment) {
        this.showStep = 3;
        this.twoStep = false;
        let data = {
          task_id: this.task_id,
          user_id: this.$store.state.user_id
        };
        this.$post(epOrderDetail, data)
                .then(res => {
                  const data = res.data;
                  this.orderTaskTitle = data.task_title;
                  this.orderTaskSn = data.task_sn;
                  this.orderTaskUrl = data.task_url;
                  this.orderCreateTime = data.create_time;
                })
                .catch(err => {
                  window.console.log(err)
                })
      } else if (this.$store.state.user_type === 0 && this.isEpAgentEdit) {
        this.$router.push({path:'/enterprise/detail'+'?id='+this.task_id})
      } else if (this.$store.state.user_type === 0 && this.isPayment) {
          this.$router.push({path:'/enterprise/detail'+'?id='+this.task_id})
      } else if (this.$store.state.user_type === 1) {
        this.showStep = 3;
        this.twoStep = false;
        //达人代客下单成功
        let data = {
          task_id: this.task_id,
          user_id: this.agentEpId
        };
        this.$post(epOrderDetail, data)
                .then(res => {
                  const data = res.data;
                  this.orderTaskTitle = data.task_title;
                  this.orderTaskSn = data.task_sn;
                  this.orderTaskUrl = data.task_url;
                  this.orderCreateTime = data.create_time;
                })
                .catch(err => {
                  window.console.log(err)
                })
      }
    },

    //企业编辑订单
    epEdit () {
      window.clearInterval(this.timer);
      this.timer = null;
      let data = {
        user_type: 0,
        id: this.editId,
        task_type: this.task_type,
        task_title: this.form.task_title,
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,
        task_time: this.form.task_time,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
        cover_img: this.form.cover_img,
      };
      this.$post(taskEdit, data)
              .then(() => {
                this.hideLoading();
                this.$message.success('修改成功');
                if (this.$store.state.user_type === 0) {
                  this.$router.push({path:'/enterprise/detail'+'?id='+this.$route.query.id})
                } else if (this.$store.state.user_type === 1) {
                  this.$router.push({path:'/daren/agentDetail'+'?id='+this.$route.query.id})
                }
              })
              .catch(err => {
                setTimeout(() => {
                  this.hideLoading();
                },1000);
                window.console.log(err);
                setTimeout(() => {
                  this.$message.error('很抱歉，修改失败，请重新再试');
                  this.hideLoading();
                }, 1000);
              })
    },

    //代客编辑订单
    agentEdit () {
      let data = {
        user_type: 0,
        user_id:this.agentUserId,
        task_id:this.editId,
        task_type: this.task_type,
        task_title: this.form.task_title,
        task_content: this.form.task_content,
        receipt_time: this.form.receipt_time,
        task_time: this.form.task_time,
        task_price: this.form.task_price,
        task_clicks: this.form.task_clicks,
        task_show: this.form.task_show,
        is_template: this.insE,
        template_id: this.ins,
        template_data: this.templateData,
        cover_img: this.form.cover_img
      };
      this.$post(UpdateTask,data)
              .then(() => {
                this.hideLoading();
                this.$message.success('修改成功');
                this.$router.push({path:'/daren/agentDetail'+'?id='+this.$route.query.id})
              })
    },

    previewCode () {
      this.dialogCode=true
    },
    //支付状态判断
    paymentResult () {
      let data = {
        pay_type: 0,
        out_trade_no: this.task_sn,
      };
      this.$post(payResult,data)
              .then( () => {
                window.clearInterval(this.timer);
                this.timer = null;
                this.isOrderPayment = true;
                this.paymentTips = '订单已支付成功';
                setTimeout(() => {
                  // this.$router.push({path:'/enterprise/detail'+'?id='+this.task_id})
                  this.releaseSuccess()
                  //微信支付成功后跳转详情
                }, 1000);
              })
              .catch( () => {
              })
    },
    // 上传图片前
    beforeUploadImg() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    // 上传图片成功
    uploadImgSuccess(res) {
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.code === 10000 && res.task_img !== null) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.task_img为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.task_img);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 上传图片失败
    uploadImgError (res, file) {
      window.console.log(res);
      window.console.log(file);
    },
    onEditorChange () {},
    onEditorReady () {},
    cancel () {
      this.$router.push('/enterprise/manage')
    },
    getInfo () {
      let data = {
        ep_id: this.$store.state.user_id,
      };
      this.$post(epInfo,data)
              .then(res => {
                let data = res.data;
                this.balance = Number(data.money);
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    getOrderDetail () {
      if (this.isEdit) {
        this.form.payment = 1;
        this.meal = 1;
      } else if (this.isAgentEdit) {
        this.form.payment = 1;
        // this.meal = 1;
      }
      let data = {
        task_id:this.editId,
        user_id: this.$store.state.user_id
      };
      this.$post(epOrderDetail, data)
              .then(res => {
                const data = res.data;
                this.form.task_title = data.task_title;
                this.form.task_price = data.task_price;
                this.form.task_clicks = data.task_clicks;
                this.form.task_show = data.task_show;
                this.task_type = data.task_type_id;
                this.form.receipt_time = String(data.receipt_time);
                this.form.task_time = String(data.task_time);
                this.is_pay = data.is_pay;
                this.releaseType = data.type;
                this.xcmini_enterprise_user = data.xcmini_enterprise_user;
                this.templateData = data.template_data;
                this.insE = Number(data.is_template);
                this.reward_type = Number(data.reward_type);
                this.form.cover_img = data.cover_img;
                this.relate_id = Number(data.relate_id);
                this.ins = Number(data.template_id);
                if (this.reward_type === 4) {
                  this.form.task_price = Number(data.split_price)
                }
                  if (this.insE === 0) {
                      this.form.task_content = data.task_content;
                  } else if (this.insE === 1) {
                    switch (this.ins) {
                      case 0:
                        this.propaganda = JSON.parse(data.template_data);
                        break;
                      case 1:
                        this.education = JSON.parse(data.template_data);
                        break;
                      case 2:
                        this.recruitment = JSON.parse(data.template_data);
                        break;
                      case 3:
                        this.restaurant = JSON.parse(data.template_data);
                        break;
                      case 4:
                        this.automobile = JSON.parse(data.template_data);
                        break;
                  }

                  }

              })
              .catch(err => {
                window.console.log(err)
              })
    },
    // 点击预览
    preview () {
      // this.$store.commit('changeMobileCon',this.form.task_content);
      // this.$store.commit('changeMobileTit',this.form.task_title);
      // this.showMobile();
      this.$refs.OrderTemplate.clearEditable();
    },
    previewCustom () {
      this.showLoading();
      this.$store.commit('changeMobileCon',this.form.task_content);
      setTimeout( () => {
        this.hideLoading();
        this.showMobileA();
      },1000)
    },
    selectPayment (index) {
      if (index === 1) {
        this.form.payment = 1
      } else {
        this.form.payment = 2
      }
    },
    handleClose () {
      this.hideLoading();
      this.dialogVisible = false;
      window.clearInterval(this.timer);
      this.timer = null
    },
    // 订单套餐方法
    // 点击 传索引 将点击时将价格=form.task_price 将边框显示
    setMeal (index) {
      this.meal=index;
      if (this.reward_type === 0) {
        this.form.task_price = this.priceList[index].price;
        this.form.task_show = this.priceList[index].show;
        this.form.task_clicks = this.priceList[index].click;
      } else if (this.reward_type === 4) {
        this.form.task_show = this.priceList[index].show;
        this.form.task_clicks = this.priceList[index].click;
      } else {
        this.form.task_show = this.priceList[index].show;
        this.form.task_clicks = this.priceList[index].click;
        this.form.task_price = '0.00'
      }
    },
    setReward (index) {
      if (this.status === 0) {
        this.reward_type = index;
        this.form.task_price = '';
        this.meal = ''
      } else if (this.status === 1) {
          if (index > 0) {
            if (this.$store.state.rank === 2) {
            this.$message.error('黄金会员一天只可以发布3次非赏金的订单')
          } else if (this.$store.state.rank === 3) {
            this.$message.error('钻石会员一天只可以发布5次非赏金的订单')
          }
        } else {
          this.reward_type = index;
          this.form.task_price = '';
          this.meal = ''
        }
      }
      
    },
    setCoupon (index,couponId) {
      this.couponMeal = index
      this.relate_id = couponId
    },
    setCard (index,cardId) {
      this.cardMeal = index
      this.relate_id = cardId
    },
    setGoods (index,goodsId) {
      this.goodsMeal = index
      this.relate_id = goodsId
    },
    paymentYes () {
      this.form.payment = 1
    },
      goToPayment () {
          this.oneStep = !this.oneStep;
          this.twoStep = !this.twoStep;
          this.showStep = 2;
      },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      const isLt1M = file.size / 1024 < 1024;

      if (!isJPG && !isPNG && !isGif) {
        this.$message.error('图片格式只能是JPG、GIF或者PNG格式!');
      }
      if (isJPG || isPNG || isGif) {
        if (!isLt1M) {
          this.$message.error('图片大小不能超过1M');
        }
      }
      return (isJPG || isPNG || isGif) && isLt1M;
    },
    handleLogoSuccess(res) {
      this.form.cover_img = res.task_img;
    },
    delLogo() {
      this.form.cover_img = "";
    },
    couponList () {
            let data = {
                user_type:0,
                user_id:this.$store.state.user_id,
                page:0
            };
            this.$post(couponList,data)
            .then(res => {
                let data = res.data;
                this.couponDataList = data.list
            })
        },
        cardList () {
            let data = {
                user_type:0,
                user_id:this.$store.state.user_id,
                page:0
            };
            this.$post(experienceCardList,data)
            .then(res => {
                let data = res.data;
                this.cardDataList = data.list
            })
        },
        goodsList () {
            let data = {
                user_type:0,
                user_id:this.$store.state.user_id,
                page:0
            };
            this.$post(goodsList,data)
            .then(res => {
                let data = res.data;
                this.goodsDataList = data.list
            })
        },
        spiltRule () {
          let data = {
            key:'spilt_rule'
          };
          this.$post(updateConfig,data)
          .then( res => {
            this.spilt_rule = JSON.parse(res.data)
          })
        },
        checkTaskNum () {
          if (this.$store.state.user_type === 0) {
            let data = {
            user_type:0,
            user_id:this.$store.state.user_id
          };
          this.$post(checkTaskNum,data)
          .then( res => {
            this.status = res.data.status
          })
          }
        }
    // routPush(){
    //    window.onload = e=>{
    //      console.log(localStorage.showStep)
    //      this.$router.push('/enterprise/order')
    //    }
    // },
    // dated(){
    //  window.onbeforeunload = e=>{
    //   //  localStorage.showStep
    //    console.log('撒大声地',localStorage.showStep)
    //    if(localStorage.showStep !=1){
    //      this.routPush();
    //    }
    //  }
    // }
  },
  watch: {
    templateText (val) {
      switch (this.getData) {
        case 2:
          this.propaganda.form2 = val;
          break;
        case 3:
          this.propaganda.form3 = val;
          break;
        case 4:
          this.propaganda.form4 = val;
          break;
        case 5:
          this.propaganda.form5 = val;
          break;
        case 6:
          this.propaganda.form6 = val;
          break;
        case 7:
          this.propaganda.form7 = val;
          break;
        case 10:
          this.propaganda.form10 = val;
          break;
        case 11:
          this.propaganda.form11 = val;
          break;
        case 12:
          this.propaganda.form12 = val;
          break;
        case 14:
          this.propaganda.form14 = val;
          break;
        case 15:
          this.propaganda.form15 = val;
          break;
        case 16:
          this.propaganda.form16 = val;
          break;
        case 17:
          this.propaganda.form17 = val;
          break;
        case 19:
          this.education.form19 = val;
          break;
        case 20:
          this.education.form20 = val;
          break;
        case 21:
          this.education.form21 = val;
          break;
        case 22:
          this.education.form22 = val;
          break;
        case 23:
          this.education.form23 = val;
          break;
        case 24:
          this.education.form24 = val;
          break;
        case 26:
          this.education.form26 = val;
          break;
        case 27:
          this.education.form27 = val;
          break;
        case 28:
          this.education.form28 = val;
          break;
        case 29:
          this.education.form29 = val;
          break;
        case 30:
          this.education.form30 = val;
          break;
        case 32:
          this.education.form32 = val;
          break;
        case 34:
          this.education.form34 = val;
          break;
        case 35:
          this.education.form35 = val;
          break;
        case 36:
          this.education.form36 = val;
          break;
        case 37:
          this.education.form37 = val;
          break;
        case 38:
          this.recruitment.form38 = val;
          break;
        case 40:
          this.recruitment.form40 = val;
          break;
        case 41:
          this.recruitment.form41 = val;
          break;
        case 42:
          this.recruitment.form42 = val;
          break;
        case 43:
          this.recruitment.form43 = val;
          break;
        case 44:
          this.recruitment.form44 = val;
          break;
        case 45:
          this.recruitment.form45 = val;
          break;
        case 49:
          this.recruitment.form49 = val;
          break;
        case 50:
          this.recruitment.form50 = val;
          break;
        case 51:
          this.recruitment.form51 = val;
          break;
        case 52:
          this.recruitment.form52 = val;
          break;
        case 53:
          this.recruitment.form53 = val;
          break;
        case 54:
          this.recruitment.form54 = val;
          break;
        case 55:
          this.recruitment.form55 = val;
          break;
        case 56:
          this.recruitment.form56 = val;
          break;
        case 57:
          this.recruitment.form57 = val;
          break;
        case 58:
          this.recruitment.form58 = val;
          break;
        case 59:
          this.recruitment.form59 = val;
          break;
        case 60:
          this.recruitment.form60 = val;
          break;
        case 61:
          this.recruitment.form61 = val;
          break;
        case 63:
          this.recruitment.form63 = val;
          break;
        case 65:
          this.restaurant.form65 = val;
          break;
        case 66:
          this.restaurant.form66 = val;
          break;
        case 67:
          this.restaurant.form67 = val;
          break;
        case 68:
          this.restaurant.form68 = val;
          break;
        case 70:
          this.restaurant.form70 = val;
          break;
        case 71:
          this.restaurant.form71 = val;
          break;
        case 73:
          this.restaurant.form73 = val;
          break;
        case 74:
          this.restaurant.form74 = val;
          break;
        case 75:
          this.restaurant.form75 = val;
          break;
        case 76:
          this.restaurant.form76 = val;
          break;
        case 78:
          this.restaurant.form78 = val;
          break;
        case 82:
          this.restaurant.form82 = val;
          break;
        case 83:
          this.restaurant.form83 = val;
          break;
        case 84:
          this.restaurant.form84 = val;
          break;
        case 86:
          this.automobile.form86 = val;
          break;
        case 88:
          this.automobile.form88 = val;
          break;
        case 89:
          this.automobile.form89 = val;
          break;
        case 92:
          this.automobile.form92 = val;
          break;
        case 93:
          this.automobile.form93 = val;
          break;
        case 96:
          this.automobile.form96 = val;
          break;
        case 97:
          this.automobile.form97 = val;
          break;
        case 98:
          this.automobile.form98 = val;
          break;
        case 99:
          this.automobile.form99 = val;
          break;
        case 101:
          this.automobile.form101 = val;
          break;
        case 102:
          this.automobile.form102 = val;
          break;
      }
    },
    task_type (val) {
      if (val == 4) {
        this.reward_type = 0
        this.price_type = 1
        this.getPrice()
      } else if (this.$store.state.user_type === 1) {
        this.reward_type = 0
        this.price_type = 0
        this.getPrice()
      } else if (val == 1 || val ==2 || val == 3) {
        if (!this.isEdit && !this.isAgain && !this.isAgentEdit && !this.isEpAgentEdit) {
          this.reward_type = ''
        }
        this.price_type = 0
        this.getPrice()
      }
    },
    reward_type (val) {
      this.couponMeal = ''
      this.cardMeal = ''
      if (val === 1) {
        if (!this.isEdit && !this.isAgain && !this.isAgentEdit && !this.isEpAgentEdit) {
          this.relate_id = ''
        }
        this.couponList()
        this.form.payment = 2
      } else if (val === 2) {
        if (!this.isEdit && !this.isAgain && !this.isAgentEdit && !this.isEpAgentEdit) {
          this.relate_id = ''
        }
        this.cardList()
        this.form.payment = 2
      } else if (val === 3) {
        if (!this.isEdit && !this.isAgain && !this.isAgentEdit && !this.isEpAgentEdit) {
          this.relate_id = ''
        }
        this.goodsList()
        this.form.payment = 2
      } else if (val === 4) {
        if (!this.isEdit && !this.isAgain && !this.isAgentEdit && !this.isEpAgentEdit) {
          this.relate_id = ''
        }
        this.form.payment = 2
      }
    }
  },
  destroyed() {
    this.timer && window.clearInterval(this.timer);
    this.timer = null;
  },
  created() {
    this.getType();
    this.getPrice();
    if (this.$store.state.user_type === 0) {
      this.getInfo();
    }
    if (this.isEdit || this.isAgentEdit || this.isAgain || this.isEpAgentEdit || this.isPayment || this.paymentEdit) {
      this.getOrderDetail();
    }
    if (this.$store.state.user_type === 1) {
      this.paymentYes()
    }
    if (this.isPayment) {
        this.goToPayment()
    }
    this.spiltRule();
    this.checkTaskNum()
  }
}
</script>
<style>
    .el-radio-button{margin-right: 20px;margin-bottom:20px;}
    .el-radio-button__inner{padding:25px 0;border:1px #eee solid;border-radius: 4px;}
    .el-radio-button:first-child .el-radio-button__inner{border-radius: 4px;}
    .select-click .is-active .el-radio-button__inner .item .estimate{color:#fff;}
    .stepTitle{font-size: 14px;margin:40px 0 20px 0;}
    .expect{font-size: 14px;margin-bottom: 20px;}
    .select-payment .item{width: 160px;height:40px;border:1px #d9d9d9 solid;border-radius: 5px;cursor: pointer;opacity: .5}
    .select-payment img{filter: grayscale(100%);margin-right:8px;}
    .select-payment .item:hover{opacity: 1;border: 1px #FF741F solid;}
    .select-payment .item:hover img{filter: grayscale(0%);}
    .select-payment .item:first-child{margin-right: 10px;}
    .select-payment .active{opacity: 1;border: 1px #FF741F solid;}
    .select-payment .active img{filter: grayscale(0%);}
    .select-payment .no-balance{cursor: default;}
    .select-payment .no-balance:hover{opacity: .5;border: 1px #d9d9d9 solid;}
    .select-payment .no-balance:hover img{filter: grayscale(100%);}

    .formBox{width:500px;}
    .select-click{margin:20px 0;}
    .select-click .item{width:200px;height:auto;}
    .select-click .item p{width: 100%;text-align: center;}
    .select-click .item .number{font-size:36px;}
    .select-click .item .estimate{color: #999;margin-top:10px;}
    .select-click .item .price{font-size:16px;margin-top:10px;}
    .btn{margin-top:50px;}
    .showClicks{margin:0 0 20px 0;}
    .showClicks span{float:left;}
    .showClicks .clicks{font-size: 30px;}
    .editor {
      line-height: normal !important;
    }
    .editor .ql-container {
      height: 350px;
    }
    .manage-content{height: calc(100% - 60px)}
    .release-steps{width:calc(100% - 340px)}
    .release-steps .item{width: 40%;}
    .release-steps .item:last-child{width: 20%;}
    .release-steps .item .num{width: 32px;height: 32px;line-height:32px;display: inline-block;text-align: center;border-radius: 100%;border:1px #d9d9d9 solid;background: #fff;color:#d9d9d9;}
    .release-steps .item .text{margin: 0 20px;font-size: 14px;}
    .release-steps .item .line{width:calc(100% - 126px);height: 2px;background: #d9d9d9;display: inline-block;font-size: 0;margin-right:20px;}
    .release-steps .current .num{background: #FF741F;color:#fff;border: 1px #FF741F solid;}
    .release-steps .already .num{background: #fff;border:1px #FF741F solid;color:#FF741F;}
    .release-steps .already .line{background: #FF741F;}
    .operation{position: absolute;right:0;margin-right:30px;}
    .operation .btn{width: 160px;margin-top:0;}
    .operation-main{margin: 20px 0;height: calc(100% - 60px)}
    .order-content{width: 50%;height:100%;background: #F0F2F5;border-radius:8px 8px 0 0;}
    .order-content .tit{height: 40px;line-height:40px;color: #B8B8B8;font-size: 14px;padding: 0 20px;}
    .order-content .con{height:calc(100% - 30px);overflow-y: scroll;}
    .order-select{width: 50%;padding-left:40px;font-size:14px;}
    .order-select .div-box{width: 100%;margin: 10px 0 0 0;}
    .order-select .global{color:#b8b8b8; margin: 10px 0 20px 0;position:relative;}
    .order-select .global .reset{position: absolute;right:0;cursor: pointer;}
    .order-select .div-box .tit{width: 80px;}
    .order-select .div-box .ul-box{width: calc(100% - 80px);}
    .order-select .div-box .ul-box li{width: 20%;text-align: center;background: #F0F2F5;cursor: pointer;}
    .order-select .div-box .ul-box li:first-child{border-radius: 4px 0 0 4px;}
    .order-select .div-box .ul-box li:last-child{border-radius: 0 4px 4px 0;}
    .order-select .div-box .ul-box li span{height:32px;line-height: 32px;display: block;margin: 2px;}
    .order-select .div-box .ul-box .active span{background: #fff;border-radius: 4px;color: #FF741F;}
    .order-select .div-box .select li{width: 40%;}
    .edit-box{width: 100%;margin:50px 0 0 0;}
    .default-show{background: #FAFAFA;width: 100%;height: 280px;text-align: center;padding: 50px 0;}
    .default-show p{width: 100%;}
    .default-show .click{font-size: 20px;color: #7BC0FF;font-weight: bold;}
    .default-show .tips{color: #b8b8b8;font-size: 14px;}
    .already-select{color:#b8b8b8;}
    .el-upload__text .textA{color:#000;font-size: 14px;}
    .el-upload__text .textB{color:rgba(153, 153, 153, 1);font-size: 12px;margin-top:6px;}
    .upload-icon{margin:45px 0 15px 0;display: inline-block;}
    .upload-icon img{width:42px;}
    .left-text{width: 80px;line-height: 40px;}
    .upload-demo{width:calc(100% - 80px);}
    .reset-default{width: 122px;height:36px;line-height:36px;text-align: center;display: inline-block;border:1px rgba(240, 242, 245, 1) solid;cursor: pointer;border-radius: 4px;}
    .custom-box{margin-top:20px;width: 100%;}
    .epList li{border:1px #e8e8e8 solid;padding:0 10px;text-align:center;height:40px;line-height: 40px;border-radius: 5px;cursor: pointer;color:#ccc;margin-right:10px;}
    .epList li:hover{border:1px #ccc solid;color:#000;}
    .epList .active{border:1px #FF741F solid;color:#000;}
    .paid{line-height: 40px;}
    .reward-type span{border:1px #eee solid;border-radius: 5px;cursor: pointer;padding:0 15px;height:40px;line-height: 40px;color:#999;margin-right:10px;}
    .reward-type span:hover{border:1px #FF741F solid;color:#FF741F;}
    .reward-type .active{border:1px #FF741F solid;color:#FF741F;}
    .imgBox {display: flex;flex-wrap:wrap;}
    .imgBox .item-img {position: relative;width: 110px;height: 110px;margin-right: 10px;margin-bottom:10px;}
    .imgBox .item-img .delIcon {position: absolute;font-size: 20px;color: #c60c1b;top: -3px;right: -5px;}
    .imgBox .item-img img {width: 110px;height: 110px;display: block;border-radius: 5px;}
    .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
    .avatar-uploader .el-upload:hover {border-color: #ff9203;}
    .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 110px;height: 110px;line-height: 110px;text-align: center;}
    .cover-tips{font-size:12px;color:#999;}
    .reward-list .item{position: relative;cursor: pointer;}
    .reward-list .item .select{width: 24px;height: 24px;line-height:24px;display: block;text-align: center;background: #ddd;right:0;bottom:0;border-radius: 5px 0 0 0}
    .reward-list .item .select .el-icon-check{color:#fff;font-size: 16px;font-weight: bold;}
    .reward-list .active{border:3px #FF741F solid;}
    .reward-list .active .select{background:#FF741F;}
    .no-reward{line-height: 40px;}
    .no-reward a{color:#FF741F;}
    .recruit-meal li{height:80px;}
    .no-select span ,.no-select .item ,.no-select li{cursor: not-allowed;}
</style>
